import { callApi } from "Apis";
import { EVENTATTENDANCEURL } from "helpers/constant";

export async function eventAttendanceList(data) {
  try {
    const response = await callApi({ url: EVENTATTENDANCEURL.LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}
